import AxiosNode from '@/services/api/node/axios_node'

export default {
  getTenantFields: (tenantId) => {
    // The numeric route also returns global fields (tenant_id IS NULL).
    return AxiosNode.get(`/field/tenant/${tenantId ?? 0}`)
  },

  getNodeFieldValues: (nodeId) => {
    return AxiosNode.get(`/field/node/${nodeId}/fieldvalue`)
  },

  saveFormValues: (nodeId, data) => {
    return AxiosNode.post(`/form/node/${nodeId}`, data)
  },
}
